// extracted by mini-css-extract-plugin
module.exports = {"logo":"App_logo__1ItuU","container":"App_container__1MQN3"};